export default Object.freeze({
  aem: {
    label: 'Adobe Expierence Manager Integration',
    details:
      'If you have an AEM account that you\'d like to connect to Contently, please use this page to install a new integration. Once installed, a "Push to CMS" button will appear on your Contently story pages. Use this button to pull your completed stories into AEM.'
  },
  contently_api: {
    label: 'Contently API Integration',
    details:
      "If you'd like to use the Contently API, please use this page to add API credentials to your account."
  },
  content_portal: {
    label: 'content portal',
    details:
      "If you'd like to embed a list of your published content directly on your internal website, please use this page to create a new content portal."
  },
  custom: {
    label: 'custom CMS Integration',
    details:
      'If you have a CMS that you\'d like to connect to Contently, please use this page to install a new integration. Once installed, a "Push to CMS" button will appear on your Contently story pages. Use this button to push your completed stories to custom CMS.'
  },
  drupal: {
    label: 'Drupal Integration',
    details:
      'If you have a CMS that you\'d like to connect to Contently, please use this page to install a new integration. Once installed, a "Push to CMS" button will appear on your Contently story pages. Use this button to push your completed stories to Drupal.'
  },
  facebook: {
    label: 'Facebook Integration',
    details:
      'By authorizing Contently to connect with your Facebook page, you will be able to post updates directly from Contently.'
  },
  linkedin: {
    label: 'LinkedIn Integration',
    details:
      'By authorizing Contently to connect with your LinkedIn page, you will be able to post updates directly from Contently.'
  },
  salesforce: {
    label: 'Salesforce Integration',
    details:
      "If you'd like to connect Contently to Salesforce, please use this page to install a new integration."
  },
  social_chorus: {
    label: 'SocialChorus Integration',
    details:
      'If you\'d like to connect Contently to SocialChorus, please use this page to install a new integration. Once installed, a "Push to CMS" button will appear on your Contently story pages. Use this button to push your completed stories to SocialChorus\n'
  },
  twitter: {
    label: 'Twitter Integration',
    details:
      'By authorizing Contently to connect with your Twitter page, you will be able to post tweets directly from Contently.'
  },
  wordpress: {
    label: 'Wordpress Integration',
    details:
      'If you have a CMS that you\'d like to connect to Contently, please use this page to install a new integration. Once installed, a "Push to CMS" button will appear on your Contently story pages. Use this button to push your completed stories to Wordpress.'
  },
  zapier: {
    label: 'Zapier Integration',
    details:
      "If you'd like to use Zapier, please use this page to add API credentials to your account."
  }
});



// WEBPACK FOOTER //
// ./app/javascript/app/components/integrations/copy.js